export const getFeedbackModalStyles = () => ({
  // recommendations-feedback-modal
  '.recommendation-feedback-overlay': {
    position: 'fixed',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    backgroundColor: 'rgba(51,51,51,0.3)',
    zIndex: '1061',
    '& .recommendation-feedback-modal': {
      position: 'absolute',
      top: '50%',
      left: '50%',
      overflow: 'auto',
      outline: 'none',
      transform: 'translate(-50%,-50%)',
      marginRight: '-50%',
      width: 605,
      padding: 20,
      border: '1px solid #d9d9d9',
      background: '#fff',
      color: '#333',

      '& .form-inline': {
        '& .btn': {
          marginRight: 8,
        },
      },
      '& button.close': {
        marginTop: 3,
      },
      '& button:disabled': {
        color: '#666',
        backgroundColor: '#F4F4F4',
        border: '1px solid #CCC',
      },
      '& h3': {
        fontWeight: '600',
        marginTop: 0,
        marginBottom: 30,
      },
      '& p, & .radio': {
        paddingLeft: 10,
        fontFamily: '\'Segoe UI\', Arial, sans-serif',

        '&[data-checked=true]': {
          backgroundColor: '#DEECF9',
        },
      },
      '& div.reasons': {
        margin: '20px 0',
      },
      '& div.comments': {
        margin: '20px 0',
        '& textarea': {
          height: 75,
          width: 330,
          border: '1px #bbb solid',
          background: '#fff',
          marginBottom: 5,
        },
      },
    },
  },

  // recommendations-dismiss-feedback
  '.recommendation-dismiss-feedback-popup': {
    position: 'fixed',
    right: 10,
    bottom: 70,
    zIndex: '2000',
    '& .close': {
      right: 5,
      top: 5,
      position: 'relative',
    },
  },
  '.recommendation-dismiss-feedback-form': {
    width: 400,
    padding: 20,
    boxShadow: '0 0 5px #ccc',
    backgroundColor: '#fff',
    '& h3': {
      fontWeight: 'bold',
    },
    '& .checkbox.preference': {
      color: '#bbb',
    },
    '& button:disabled': {
      background: '#f3f2f1',
      borderColor: 'transparent',
      color: '#a19f9d',
      cursor: 'default',
    },
  },
});
